export default __webpack_public_path__ + "static/media/Pistol_7.5a5785dc.png";